// src/utils/localStorage.tsx

type LocalStorageKeys =
  | "token"
  | "userId"
  | "userName"
  | "antiforgery"
  | "antiforgerycookie"
  | "userPreferences"
  | "groupId"
  | "businessUnitId"
  | "contextName"
  | "accountId"
  | "authorizationData"
  | "firstName"
  | "lastName"
  | "metadatadefinitionId"
  | "isSuperAdmin"
  | "IsSuperAdmin"
  | "isAccountDAOEnabled"
  | "isAccountDSAEnabled"
  | "isAccountEdeliveryEnabled"
  | "isAntiforgeryCalled"
  | "theme"
  | "initialContextName"
  | "language"
  | "folderRights"; // Add all keys used in your project here

class LocalStorageUtil {
  static getItem(key: LocalStorageKeys): string | null {
    const item = localStorage.getItem(key);
    return item;
  }

  static setItem(key: LocalStorageKeys, value: any): void {
    localStorage.setItem(key, value);
  }

  static removeItem(key: LocalStorageKeys): void {
    localStorage.removeItem(key);
  }

  static clear(): void {
    localStorage.clear();
  }
}

export default LocalStorageUtil;